<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="真伪查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card shadow="never" class="search-card">
        <template #desc>
          <div class="query-limit-card">
            <div class="limit-title">每月可查询非个人球杆次数：<span class="highlight">{{ total }}</span>次</div>
            <div class="limit-subtitle">本月已用：<span class="highlight">{{ count }}</span>次 剩余：<span
                class="highlight">{{ total - count }}</span>次
            </div>
            <van-button class="go-select-btn" type="primary" @click="showPicker = true">我的球杆</van-button>
          </div>
          <!-- 选择器弹窗：保留核心 -->
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>
        </template>
      </van-card>

      <!-- 球杆序列号文本框：默认显示，保留点击选择逻辑 -->
      <div class="serial-input-section">
        <div class="serial-input-wrapper">
          <div class="input-label">球杆编码</div>
          <van-field
              clearable
              v-model="number"
              placeholder="请输入球杆编码"
              class="serial-input"
              ref="serialInput"
          />
        </div>
      </div>

      <!-- 查询按钮：默认显示，有值才展示 -->
      <van-button class="search-btn" block @click="search">查询</van-button>
    </div>

    <!-- 查询结果：保留核心 -->
    <div class="result-container">
      <van-card shadow="never" class="result-card" v-if="htmlContent">
        <template #desc>
          <div class="content-item" v-html="htmlContent"></div>
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {checkPortal, checkPortalByMemberCount, productByUser} from "@/api/sales";
import {Dialog} from "vant";

export default {
  data() {
    return {
      number: '',        // 序列号（手动输入/选择）
      selectOptions: [], // 我的球杆列表
      showPicker: false, // 选择器弹窗
      htmlContent: '',   // 查询结果html
      total: 0,          // 每月可查询总次数
      count: 0,          // 本月已用次数
      isInputReadonly: false // 输入框是否只读（选择球杆时只读）
    }
  },
  created() {
    // 初始化：获取我的球杆列表 + 获取查询次数
    this.selectProductByUser();
    this.checkPortalByMemberCount();
  },
  methods: {
    // 返回首页
    onClickLeft() {
      this.$router.push('/app_home');
    },
    // 输入框点击事件：只读状态下弹出选择器（保留核心）
    handleInputClick() {
      if (this.isInputReadonly) {
        this.showPicker = true;
      }
    },
    // 选择器确认选择（保留核心，逻辑不变）
    onConfirm(value) {
      this.showPicker = false;
      this.number = value;
    },
    // 序列号去空格
    trimNumber() {
      this.number = this.number.trim();
    },
    // 弹窗提示通用方法
    showDialogMsg(message) {
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
    // 获取我的球杆序列号列表
    selectProductByUser() {
      productByUser().then(res => {
        if (res.code === 200) {
          if (res.data && res.data.length) {
            this.selectOptions = res.data.map(item => item.value);
          } else {
            Dialog.alert({
              title: '提示',
              message: '当前无已登记的球杆编码，请手动输入',
            });
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '获取球杆编码失败',
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '获取球杆编码失败，请稍后重试',
        });
      })
    },
    // 获取每月查询次数
    checkPortalByMemberCount() {
      checkPortalByMemberCount().then(res => {
        if (res.code === 200 && res.data) {
          this.total = res.data.total;
          this.count = res.data.count;
        }
      }).catch(error => {
        this.$message?.error("网络异常，获取查询次数失败");
      })
    },
    // 核心查询逻辑（保留不变）
    search() {
      this.trimNumber();
      if (!this.number) {
        this.showDialogMsg('请输入球杆编码');
        return;
      }
      this.htmlContent = "";
      // 非个人球杆且次数用完，禁止查询

      // 判断是否是个人球杆（在selectOptions中）
      const isMyClub = this.selectOptions.includes(this.number);

      if (!isMyClub && (this.total - this.count) <= 0) {
        this.showDialogMsg('查询非个人球杆权益次数已用完');
        this.number = '';
        this.htmlContent = '';
        return;
      }
      checkPortal(this.number).then(res => {
        if (res.code === 200) {
          const data = res.data;
          const code = data.code;
          let msgStr = "";
          if (code === 5) {
            msgStr = `<p class="no-margin">此杆号查询次数较多，疑似克隆号，请联系经销商或者联系官方售后确认</p>
                      <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>`;
            this.htmlContent = msgStr;
          } else if (code === 0) {
            this.htmlContent = msgStr;
          } else if (code === 2) {
            msgStr = `<p>很遗憾，您所查询的杆号非璟点公司提供正品行货，没有售后保障。请联系官方售后电话或找附近经销商确认。</p>
                      <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>`;
            this.htmlContent = msgStr;
          } else if (code === 1) {
            if (data.check_number > 5) {
              msgStr = `<p>此杆号查询次数较多，疑似克隆号，请联系经销商或者联系官方售后确认</p>
                        <p>官方售后咨询：<a href="tel:18603360681">18603360681</a></p>`;
              this.htmlContent = msgStr;
            } else {
              let agent_name = "";
              if (data.agent_name && data.agent_name !== '') {
                agent_name = "，授权销售商为[<span>" + data.agent_name + "</span>]";
              }
              msgStr = `
                <p>恭喜您！编号[<span>${data.portal_number}</span>]商品为正品，请您放心使用。</p>
                <p>${data.portalSpecs ? '该编号商品为[<span>' + data.portalSpecs + '</span>]' : ''}</p>
                <p>该编号商品出货日期为[<span>${data.create_time}</span>]${agent_name}</p>
                <p>该编号商品已查询[<span>${data.check_number}</span>]次</p>
                <p>上次查询时间[<span>${data.cx_time}</span>]</p>
              `;
              this.htmlContent = msgStr;
            }
          }
          // 查询后更新次数
          this.checkPortalByMemberCount();
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '查询失败，请稍后重试',
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '查询失败，请检查网络或稍后重试',
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

// 主容器
.container-item {
  padding: 0 16px;
}

// 搜索卡片（背景图）
.search-card {
  margin: 16px 0;
  border-radius: 12px;
  height: auto;
  background-image: url('~@/assets/img/h5/search_bj.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 16px;
  overflow: visible !important;
}

// 次数统计卡片
.query-limit-card {
  background: #1A1A1A;
  border: 1px solid #D4AF37;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 150px;
  margin-bottom: -50px;
  position: relative;
  z-index: 10;
}

.limit-title {
  color: #D4AF37;
  font-size: 14px;
  font-weight: bold;
}

.limit-subtitle {
  color: #FFF;
  font-size: 12px;
  padding-right: 80px;
}

.highlight {
  color: #D4AF37;
  font-weight: bold;
}

// 我的球杆按钮（原去选择按钮，样式不变）
.go-select-btn {
  position: absolute;
  right: 16px;
  bottom: 12px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 12px;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  margin-top: 0 !important;
  height: auto;
}

// 球杆序列号输入框样式
.serial-input-section {
  margin: 52px 16px 16px;
}

.serial-input-wrapper {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 48px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.input-label {
  color: #000;
  font-size: 14px;
  font-weight: bold;
  padding-right: 16px;
  border-right: 1px solid #000;
  margin-right: 16px;
}

.serial-input {
  flex: 1;

  ::v-deep .van-field__control {
    color: #000 !important;
    background: transparent !important;
  }

  ::v-deep .van-field__placeholder {
    color: #333 !important;
  }

  ::v-deep .van-field {
    border: none !important;
    background: transparent !important;
  }
}

// 查询按钮
.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  margin-top: 16px;
}

// 结果容器
.no-margin {
  margin: 0;
}

.result-container {
  padding: 0 16px;
  margin-top: 20px;
}

.result-card {
  border-radius: 12px;
  background-color: #fff;
}

// 结果内容样式
:deep(.content-item) {
  width: 100%;
  text-align: center;

  p {
    font-size: 14px;
    line-height: 2;
    span {
      color: #B8860B;
    }
  }

  a {
    color: #B8860B;
    text-decoration: underline;
    font-weight: 500;
  }
}

// Vant字段适配
::v-deep .van-field__label {
  line-height: 32px;
}

::v-deep .van-field__button {
  margin-right: 0;
  padding: 0;
}
</style>